import { render, staticRenderFns } from "./DocumentCheckIcon.vue?vue&type=template&id=6639b97e"
import script from "./DocumentCheckIcon.vue?vue&type=script&lang=js"
export * from "./DocumentCheckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports